import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const initialState = {
	drawerOpen: false,
  routeHistory: [],
  saveDashboardFormStates: false,  
};

export const checkRouteHistory = createAsyncThunk(
  "global/checkRouteHistory",
  async(obj, { getState }) => {
    const history = getState().global.routeHistory;
    // console.log(history);
    const prevPage = history[history.length - 2];
    const pages = ["quota-details", "scenario", "quota-modification", "quota"];

    if (prevPage && pages.includes(prevPage)) {
      return true;
    }
    return false;
  }
);

export const appendRoute = createAsyncThunk(
  "global/appendRoute",
  async (route, { getState }) => {
    return getState().global.routeHistory;
  }
);

export const globalSlice = createSlice({
	name: "global",
	initialState,
	reducers: {
		setGlobalState: {
			prepare(stateName, stateValue) {
				return {
					payload: { stateName, stateValue },
				};
			},
			reducer(state, action) {
				const { stateName, stateValue } = action.payload;
				state[stateName] = stateValue;
			},
		},
    pushRoute: (state, action) => {
      state.routeHistory.push(action.payload);
      // keeping the array size upto 10 so that it doesn't use too much memory
      if (state.routeHistory.length > 10) {
        let smallerHistory = state.routeHistory.slice(5);
        state.routeHistory = smallerHistory;
      }
    },
    setSaveDashboardFormState: (state, action) => {
      state.saveDashboardFormStates = action.payload;
    }
	},
  extraReducers: (builder) => {
    builder
    .addCase(checkRouteHistory.pending, () => {})
    .addCase(checkRouteHistory.fulfilled, (state, action) => {      
    })
    .addCase(checkRouteHistory.rejected, () => {})

    .addCase(appendRoute.pending, (state, action) => {
      state.routeHistory.push(action.payload);
    })
    .addCase(appendRoute.fulfilled, (state, action) => {
      console.log(state.routeHistory);
    })
    .addCase(appendRoute.rejected, (state) => {
      console.log(state.routeHistory);
    })
  }
});

export const { setGlobalState, pushRoute, setSaveDashboardFormState } = globalSlice.actions;
export default globalSlice.reducer;
